//
// AUTO-GENERATED FILE. DO NOT MODIFY.
//
// This class was automatically generated by Apollo GraphQL version '3.8.5'.
//
package graphql.adapter

import com.apollographql.apollo3.api.Adapter
import com.apollographql.apollo3.api.CustomScalarAdapters
import com.apollographql.apollo3.api.StringAdapter
import com.apollographql.apollo3.api.json.JsonReader
import com.apollographql.apollo3.api.json.JsonWriter
import graphql.GetTradeNewsByCategoryQuery
import kotlin.IllegalStateException
import kotlin.Unit

public object GetTradeNewsByCategoryQuery_VariablesAdapter : Adapter<GetTradeNewsByCategoryQuery> {
  public override fun fromJson(reader: JsonReader, customScalarAdapters: CustomScalarAdapters):
      GetTradeNewsByCategoryQuery = throw
      IllegalStateException("Input type used in output position")

  public override fun toJson(
    writer: JsonWriter,
    customScalarAdapters: CustomScalarAdapters,
    `value`: GetTradeNewsByCategoryQuery,
  ): Unit {
    writer.name("category")
    StringAdapter.toJson(writer, customScalarAdapters, value.category)
  }
}
